import { Component } from '@angular/core';

@Component({
  templateUrl: './text-box.html'  
})
export class TextBoxComponent { 
    constructor() { }

    public TextBoxText:string = "Text";
    public TextareaText:string = "Textarea";
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/text-box/text-box-component.ts